import Handsontable from 'handsontable';

/**
 * Gets the column widths in pixels, via a handsontable instance
 */
export const getHotColWidths = (hotInstance: Handsontable | null | undefined): number[] | undefined => {
    if (!hotInstance) return;

    const colWidthsPx: number[] = [];

    const colCount = hotInstance.countCols();

    for (let col = 0; col < colCount; col++) {
        const isLastCol = col === colCount - 1;
        const offset = isLastCol ? 2 : 0;

        const width = hotInstance.getColWidth(col) + offset;

        colWidthsPx.push(width);
    }

    return colWidthsPx;
};

/**
 * Gets the column widths in grid units, via a handsontable instance.
 */
export const getHotColWidthsGu = (
    hotInstance: Handsontable | null | undefined,
    gridSize: number,
): number[] | undefined => {
    const colWidths = getHotColWidths(hotInstance);

    if (!colWidths) return;

    return colWidths.map((width) => width / gridSize);
};
